/* tslint:disable:max-line-length indent no-trailing-whitespace component-selector */
import { of as observableOf, Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SearchRequest } from 'app/views/program-work/search-request.model';

@Injectable({ providedIn: 'root' })
export abstract class DataService<T> {
    protected url: string;
    private allData = new ReplaySubject<T[]>(1);

    constructor(protected httpClient: HttpClient, protected entity: string) {
        this.url = '/api/' + entity;
    }

    public search(term: string): Observable<T[]> {
        if (!term) {
            return observableOf([]);
        }

        return this.httpClient.get<T[]>(this.url + '?search=' + term);
    }

    public getDetails(id: number, params?: any): Observable<T> {
        return this.httpClient.get<T>(this.url + '/' + id, { params: params });
    }

    public getAll(cache: boolean): Observable<T[]> {
        if (!this.allData.observers.length || !cache) {
            this.httpClient.get<T[]>(this.url).subscribe(
                data => this.allData.next(data),
                error => {
                    this.allData.error(error);
                    this.allData = new ReplaySubject(1);
                }
            );
        }

        return this.allData;
    }

    public getFacets(searchReq: SearchRequest): string {
        if (searchReq.facets && searchReq.facets.length) {
            const escapedFacets = searchReq.facets.map(x => {
                const y = x.split('|'); y[1] = escape(y[1]);
                return `facets=${y.join('|')}`;
            }).join('&');
            return `&${escapedFacets}`;
        }
        return '';
    }
}
